<template>
  <section :class="['max-sm:px-6 max-xl:px-13 py-[50px] md:pb-24', removeDesktopPaddingTop ? 'md:pt-0' : 'md:pt-24']">
    <div class="max-w-content mx-auto flex flex-col gap-16">
      <div class="flex flex-col gap-3">
        <h2 :class="[
           'text-[30px] md:text-[36px] font-semibold leading-tight tracking-[-0.72px]',
           isDarkBackground ? 'text-grey-dark-50' : 'text-grey-light-900',
           { 'text-center': isMobile }
          ]">
          In the news
        </h2>
        <p :class="[
          'text-base md:text-xl max-w-[760px]',
          isDarkBackground ? 'text-grey-dark-300' : 'text-grey-light-600',
          { 'text-center': isMobile }
          ]">
          Celebrating our merchant success stories, industry partnerships, and thought-leadership insights shaping the future of smarter, debt-free commerce.
        </p>
      </div>

      <div class="flex flex-col md:flex-row gap-12">
        <a
          v-for="article in articles"
          :key="article.url"
          :href="article.url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex flex-col gap-5 flex-1 group"
        >
          <div class="h-[54px] flex items-center">
            <img
              :src="article.mediaLogo"
              :alt="article.mediaName"
              class="object-contain"
              :class="[article.logoClass, { 'brightness-0 invert': isDarkBackground && article.invertLogoOnDark }]"
            />
          </div>

          <div class="h-[240px] rounded-2xl overflow-hidden w-full shrink-0">
            <img
              :src="article.image"
              :alt="article.title"
              class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          <div class="flex flex-col gap-6">
            <div class="flex items-start gap-4">
              <h3 :class="['flex-1 text-2xl font-semibold leading-8', isDarkBackground ? 'text-grey-dark-50' : 'text-grey-light-900']">
                {{ article.title }}
              </h3>
              <div class="pt-1 shrink-0">
                <ArrowUpRight class="w-6 h-6" :class="isDarkBackground ? 'text-grey-dark-50' : 'text-grey-light-900'" />
              </div>
            </div>
            <p :class="['text-base', isDarkBackground ? 'text-grey-dark-300' : 'text-grey-light-600']">
              {{ article.excerpt }}
            </p>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ArrowUpRight } from 'lucide-vue-next';
import bizCommunityImage from '@/assets/images/business/news/biz-community.png';
import disruptImage from '@/assets/images/business/news/disrupt.png';
import disruptLogo from '@/assets/images/icons/news/disrupt.svg';
import bizCommunityLogo from '@/assets/images/icons/news/biz-community.svg';
import { useMediaQuery } from '@vueuse/core';

const isMobile = useMediaQuery('(max-width: 767px)');

interface Props {
  isDarkBackground?: boolean;
  removeDesktopPaddingTop?: boolean;
}

withDefaults(defineProps<Props>(), {
  isDarkBackground: true,
  removeDesktopPaddingTop: true,
});

const articles = [
  {
    url: `${import.meta.env.VITE_BASE_URL}/blog/save-now-buy-later-and-get-rewarded/`,
    mediaName: 'BizCommunity',
    mediaLogo: bizCommunityLogo,
    logoClass: 'w-[231px] h-[33px]',
    invertLogoOnDark: true,
    image: bizCommunityImage,
    title: 'Save Now. Buy Later. AND Get Rewarded!',
    excerpt: 'Why go into debt when you can BOOST?',
  },
  {
    url: `${import.meta.env.VITE_BASE_URL}/business/blog/layup-announces-boost-rewards-launching-early-2026`,
    mediaName: 'Disrupt Africa',
    mediaLogo: disruptLogo,
    logoClass: 'h-full',
    invertLogoOnDark: false,
    image: disruptImage,
    title: 'LayUp Announces BOOST',
    excerpt: 'A Game-Changing Pre-Payment and Rewards Solution',
  },
];
</script>
